import React from 'react';
import { ChildAlertProps } from '../BaseAlert.component';
import { useTranslation } from 'react-i18next';
import WarningAlertComponent from '../WarningAlert.component';
import styled from 'styled-components';

const StyledMessageWrapper = styled.div`
  white-space: pre;
`;

const InternshipCandidateRemoveAlert = ({ handleConfirm }: ChildAlertProps) => {
  const { t } = useTranslation();
  return (
    <WarningAlertComponent onClose={handleConfirm}>
      <StyledMessageWrapper>
        {t('Candidate will be removed from internship')}
        <br />
        {t('Are you sure you want to delete candidate from internship?')}
      </StyledMessageWrapper>

    </WarningAlertComponent>
  )
}

export default InternshipCandidateRemoveAlert;